<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.webpage_heading" [ttModel]="setting.webpage_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-checkbox ttRememberId="w_equipmentlist.show_all" ttLabel="show_all" [(ttModel)]="setting.show_all" (ttModelChange)="onChanged($event, 'show_all')"></tt-checkbox>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <tt-page-heading class="col-xs-12 sp-0" [tt-model]="vm.model.setting.webpage_heading"></tt-page-heading>
    <tt-card class="col-xs-12 sp-5">
        <tt-checkbox class="col-xs-12 sp-0" tt-label="show_all" tt-model="vm.model.setting.show_all" tt-change="vm.onChanged($value, 'show_all')"></tt-checkbox>
    </tt-card>
    <tt-grid class="col-xs-12 sp-5 flex-1" tt-options="vm.grid" ng-if="vm.model.gridReady"></tt-grid>
</tt-page>-->
